import React from 'react'
import { useDispatch, batch } from 'react-redux'
import { Root, Wrapper, Dates, Highlight, IconButton } from './PredictionsTopbar.styles'
import DatePicker from '../../components/Inputs/DatePicker'
import Button from '../../components/Buttons/Button'
import { onGetPredictionsSuccessThunk } from './Predictions.actions'
import { useDatePicker, useSelect } from '../../components/Inputs/Inputs.hooks'
import { startOfWeek, endOfWeek, isSameDay, isWithinInterval, format } from 'date-fns'
import { checkErrorRequired } from '../../modules/errors/validations'
import Select from '../../components/Inputs/Select'

/**
 * The Prediction topbar' container.
 */
const PredictionsTopbar = () => {
  // const now = moment()
  const dispatch = useDispatch()

  const { error: error1, value: value1, onChange: handleValue1Change } = useSelect({
    errorCallbacks: [checkErrorRequired()]
  })

  const { error: pastDateError, value: pastDateValue, onChange: handlePastDateChange } = useDatePicker({
    initialValue: new Date()
  })

  const renderWrapWeekDay = (date, selectedDate, dayInCurrentMonth, disableFuture) => {
    const dateClone = new Date(date)
    const selectedDateClone = new Date(selectedDate)

    const start = startOfWeek(selectedDateClone, { weekStartsOn: 1 })
    const end = endOfWeek(selectedDateClone, { weekStartsOn: 1 })

    const dayIsBetween = isWithinInterval(dateClone, { start, end })
    const isFirstDay = isSameDay(dateClone, start)
    const isLastDay = isSameDay(dateClone, end)

    const currmonthbetween = !dayInCurrentMonth && dayIsBetween

    return (
      <>
        <Highlight dayIsBetween={dayIsBetween} isFirstDay={isFirstDay} isLastDay={isLastDay}>
          <IconButton
            dayInCurrentMonth={!dayInCurrentMonth}
            currmonthbetween={currmonthbetween}
            dayIsBetween={dayIsBetween}
            futureDisable={disableFuture.props.disabled}
          >
            <span> {format(dateClone, 'd')} </span>
          </IconButton>
        </Highlight>
      </>
    )
  }

  const getData = () => {
    if (value1 !== '') {
      const start = startOfWeek(pastDateValue, { weekStartsOn: 1 })
      const end = endOfWeek(pastDateValue, { weekStartsOn: 1 })
      batch(() => {
        dispatch(onGetPredictionsSuccessThunk(start, end, value1))
      })
    }
  }

  return (
    <Root>
      <>
        <Wrapper>
          <Dates>
            <DatePicker
              error={pastDateError}
              value={pastDateValue}
              label="Seleccione semana"
              width="100%"
              onChange={handlePastDateChange}
              renderDay={renderWrapWeekDay}
              disableFuture
            />
          </Dates>
          <Select
            error={error1}
            label="Seleccione equipo"
            options={Array.from({ length: 25 }, (_, i) => {
              const patent = `TR${701 + i}`
              return { name: patent, value: patent }
            })}
            placeholder="select"
            value={value1}
            onChange={handleValue1Change}
          />
          <Button color="primary" onClick={getData} size="small">
            Go
          </Button>
        </Wrapper>
      </>
    </Root>
  )
}

export default PredictionsTopbar
